export default {"src":"/_next/static/media/taxi.e1df0eef.svg","height":508,"width":508};